import { drawing } from '@/page/drawing/model/type';

const state:drawing = {
    drawingId: '',
    drawingName: '',
    size: '',
    drawingType: '',
    drawingUrl: '',
    envType: '',
    scale: null,
    lastScale: null,
    minDb: '',
    layerSetting: '',
    widthPixel: 0,
    heightPixel: 0,
    // @ts-ignore
    addDrawingFlag: false,
    lastFrequencyBand: null,
    simulationUrlMap: null
};

const clearState = {
    drawingId: '',
    drawingName: '',
    size: '',
    drawingType: '',
    drawingUrl: '',
    envType: '',
    scale: null,
    lastScale: null,
    minDb: '',
    layerSetting: '',
    widthPixel: 0,
    heightPixel: 0,
    // @ts-ignore
    addDrawingFlag: false,
    lastFrequencyBand: null,
    simulationUrlMap: null
};

const mutations = {
    setDrawingConfig: (state:any, drawConfig:drawing) => {
        for (let key in drawConfig) {
            state[key] = drawConfig[key];
        }
    },
    setDrawingId: (state:any, id:string) => {
        if (id !== state.drawingId) {
            Object.assign(state, clearState);
        }
        state.drawingId = id;
    },
    setAddDrawing: (state:any, flag:boolean) => {
        state.addDrawingFlag = flag;
    },
    clearConfig: (state:any) => {
        Object.assign(state, clearState);
    }
};

export default {
    namespaced: true, // 这个是命名空间，用来区分不同的模块，我是根据文件的名字来区分
    state,
    mutations
};
